import React from 'react';
import {Control, UseFormRegister} from 'react-hook-form';

import IHttpMonitorOutput from 'features/http/model/HttpMonitor/IHttpMonitor';
import {isTranslate} from 'shared/lib/lang';

import NotifyEmail from './NotifyEmail/NotifyEmail';
import NotifyTelegram from './NotifyTelegram/NotifyTelegram';
import NotifyMax from './NotifyMax/NotifyMax';
import NotifyWebhook from './NotifyWebhook/NotifyWebhook';

interface INotifySettingsSubformProps {
    item?: IHttpMonitorOutput,
    control: Control<any>,
    register: UseFormRegister<any>,
    showWebhook?: boolean,
}

const NotifySettingsSubform: React.FC<INotifySettingsSubformProps> = ({
    item,
    control,
    register,
    showWebhook = true,
}) => {

    return (
        <>
            <NotifyEmail control={control} register={register} item={item} />
            <NotifyTelegram item={item} control={control} register={register} />
            {
                !isTranslate() &&  <NotifyMax item={item} control={control} register={register} />
            }
            {
                showWebhook && <NotifyWebhook item={item} control={control} register={register} />
            }
        </>
    );
};

export default NotifySettingsSubform;